import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import RoutesConfig from "./components/Routes/RoutesConfig";
import ContextWrapper from "./context/ContextWrapper";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <Router>
      <ContextWrapper>
        <RoutesConfig />
        <ToastContainer
          position="top-right"
          autoClose={8000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="colored"
          closeButton={true}
        />
      </ContextWrapper>
    </Router>
  );
};
export default App;